<template>
  <i class="fal fa-image text-4xl text-white"></i>
</template>
<script>
export default {

}
</script>
